module.exports = __webpack_public_path__ + "11e79600ca55d00cbe87bc2cebe38483.MP3";